import { render, staticRenderFns } from "./shipping-and-payment-method.vue?vue&type=template&id=430410cf&lang=pug&"
import script from "./shipping-and-payment-method.vue?vue&type=script&lang=js&"
export * from "./shipping-and-payment-method.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports